export const response = {
    SUCCESS: "success",
    FAIL: "fail"
}